// extracted by mini-css-extract-plugin
var _1 = "nra36";
var _2 = "ByipT";
var _3 = "ujxxS";
var _4 = "ZhzY1";
export { _1 as "base", _2 as "center", _3 as "end", _4 as "start" }
